import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'E-Mail Adresse bestätigen',
  [OnboardingStep.StoreDetails]: 'Restaurantdaten',
  [OnboardingStep.BusinessInfo]: 'Unternehmensdaten',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Details zu deinem Geschäft hinzufügen',
  [OnboardingStep.PersonalInfo]: 'Füge deine persönlichen Informationen hinzu',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Persönliche Angaben des Inhabers',
  owner_personal_info_gmbh: 'Persönliche Angaben des Inhabers / Geschäftsführers',
  [OnboardingStep.ShippingInfo]: 'Lieferdaten hinzufügen (Versand Terminal, etc)',
  [OnboardingStep.BankInfo]: 'Bankverbindung für Auszahlungen hinzufügen',
  [OnboardingStep.TaxInfo]: 'Besitzt du eine USt.-ID?',
  [OnboardingStep.BusinessDocs]: 'Unternehmen verifizieren',
  [OnboardingStep.PersonalDocs]: 'Identitätsnachweisdokument',
  [OnboardingStep.InfoSubmission]: 'Auszahlung erhalten',
  confirm_info_gateway: 'Auszahlung erhalten – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Zahlungsinformationen',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobile App',
  [OnboardingStep.DeliveryStructure]: 'Lieferstruktur',
  [OnboardingStep.Contract]: 'Vereinbarung/ Vertrag',
  [OnboardingStep.ContractPayment]: 'Vertragszahlung',
  [OnboardingStep.Documents]: 'Dokumente hochladen',
  [OnboardingStep.PromoCode]: 'Promo-Code',
};
